<template>
    <div id="pageTable" class="mainView">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-btn color="primary" dark slot="activator" @click="showAppPushModal()">PUSH 발송</v-btn>
                <v-btn color="success" dark slot="activator" @click="downloadExcel()">발송 대상 업로드 양식 다운로드</v-btn>
                <v-flex lg12>
                    <v-card>
                        <!--            <v-toolbar card color="white">-->
                        <!--              <div class="flex xs12 sm2">-->
                        <!--                <v-select-->
                        <!--                        :items="[{-->
                        <!--                          text: '프로모션 코드 고유번호',-->
                        <!--                          value: 'id'-->
                        <!--                        }]"-->
                        <!--                        name="header"-->
                        <!--                        v-model="searchFormModel.filter"-->
                        <!--                        label="header"-->
                        <!--                ></v-select>-->
                        <!--              </div>-->
                        <!--              <v-text-field-->
                        <!--                      flat-->
                        <!--                      solo-->
                        <!--                      prepend-icon="search"-->
                        <!--                      placeholder="Type something"-->
                        <!--                      v-model="searchFormModel.filterText"-->
                        <!--                      hide-details-->
                        <!--                      class="hidden-sm-and-down"-->
                        <!--                      @keyup.enter="searchFilter"-->
                        <!--              ></v-text-field>-->
                        <!--              <v-btn icon @click="searchFilter">-->
                        <!--                <v-icon>filter_list</v-icon>-->
                        <!--              </v-btn>-->
                        <!--            </v-toolbar>-->
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :items="complex.items"
                                    :rows-per-page-items="[10,25,50]"
                                    class="elevation-1"
                                    item-key="id"
                                    must-sort
                                    :pagination.sync="pagination"
                                    :total-items="totalItems"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-sm-center"><a @click="showAppPushModal(props.item.id)">{{ props.item.id }}</a></td>
                                    <td class="text-sm-center">{{ changePushMessageActionText(props.item.action) }}</td>
                                    <td class="text-sm-center">{{ props.item.userType === 'P' ? '승객' : '기사' }}</td>
                                    <td class="text-sm-center">{{ props.item.range === 'ALL' ? '전체' : '지정' }}</td>
                                    <td class="text-sm-center">{{ props.item.title }}</td>
                                    <td class="text-sm-center">{{ props.item.body }}</td>
                                    <td class="text-sm-center">{{ props.item.state }}</td>
                                    <td class="text-sm-center">{{ props.item.reservationDate }}</td>
                                    <td class="text-sm-center">{{ props.item.deleted ? 'Y' : 'N' }}</td>
                                    <td class="text-sm-center">{{ props.item.regDate }}</td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <ModalAppPushDetail></ModalAppPushDetail>
        </v-container>
    </div>
</template>

<script>
    import VWidget from '@/components/VWidget';
    import Util from '@/util';
    import ModalAppPushDetail from '../../components/modal/appPush/modal-app-push-detail';

    export default {
        components: {
            VWidget, Util, ModalAppPushDetail
        },
        data () {
            return {
                pagination: {
                    sortBy: 'id',
                    descending: true,
                    rowsPerPage: 10,
                    page: 1
                },
                totalItems: 0,
                searchFormModel: {
                    filter: 'id',
                    filterText: ''
                },
                complex: {
                    headers: [
                        {
                            text: '고유번호',
                            value: 'id',
                            align: 'center'
                        },
                        {
                            text: '타입',
                            value: 'action',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '대상',
                            value: 'userType',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '범위',
                            value: 'range',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '제목',
                            value: 'name',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '내용',
                            value: 'body',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '상태',
                            value: 'state',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '예약시간',
                            value: 'reservationDate',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '삭제여부',
                            value: 'deleted',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '등록시간',
                            value: 'regDate',
                            align: 'center',
                            sortable: false
                        }
                    ],
                    items: []
                }
            };
        },
        watch: {
            pagination: {
                handler () {
                    if (top.getApp.prevPageName === 'AppPushPage') {
                        if(top.getApp.prevPagination != null) {
                            this.pagination = top.getApp.prevPagination;
                        }

                        if(top.getApp.prevSearchFormModel != null) {
                            this.searchFormModel = top.getApp.prevSearchFormModel;
                        }

                        top.getApp.clearPrevData();
                    }

                    this.banbanCreated();
                },
                deep: true
            }
        },
        mounted () {
            for (let i = 0; i < this.$parent.$children.length; i++) {
                if (this.$parent.$children[i].chkAutoReload != null) {
                    this.$parent.$children[i].chkAutoReload();
                }
            }
        },
        methods: {
            banbanCreated () {
                const parameters = {
                    method: 'searchPushMessages',
                    pageNum: this.pagination.page - 1,
                    pageSize: this.pagination.rowsPerPage,
                    sortName: this.pagination.sortBy,
                    order: this.pagination.descending == true ? 'desc' : 'asc',
                    filter: this.searchFormModel.filter,
                    filterText: this.searchFormModel.filterText
                };

                this.$store.dispatch('banbanAPI', parameters)
                    .then(({ data }) => {
                        this.complex.items = data.content;
                        this.totalItems = data.totalElements;
                        top.getApp.progress.dialog = false;
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }
                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
            searchFilter () {
                this.banbanCreated();
            },
            showAppPushModal (id) {
                this.$modal.show('modal-app-push', {id : id, callback: this.banbanCreated});
            },
            changePushMessageActionText (action) {
                return top.getApp.changePushMessageActionText(action);
            },
            downloadExcel () {
                const parameters = {
                    method: 'downloadAppPushTargetForm',
                    responseType: 'blob',
                };

                this.$store.dispatch('banbanAPI', parameters)
                    .then((res) => {
                        top.getApp.progress.dialog = false;
                        Util.downloadFile(res);
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }
                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/appPush/AppPush.vue